"use client";
import { cn } from "@/lib/utils";

export function HamburgerButton({
	isOpen,
	onOpen,
	className,
}: {
	isOpen: boolean;
	onOpen: () => void;
	className?: string;
}) {
	const lineBaseClasses =
		"absolute block w-6 h-0.5 bg-ink transition-all duration-300";

	const line1Classes = cn(
		lineBaseClasses,
		isOpen ? "-rotate-45 translate-y-3" : "translate-y-1"
	);
	const line2Classes = cn(
		lineBaseClasses,
		isOpen ? "opacity-0" : "translate-y-5"
	);
	const line3Classes = cn(
		lineBaseClasses,
		isOpen ? "rotate-45 translate-y-3" : "translate-y-3"
	);

	return (
		<button
			onClick={onOpen}
			className={cn("flex items-center justify-center", className)}
			aria-label="Menú de navegación de Asociación Equilibrio"
			title="Menú de navegación de Asociación Equilibrio"
		>
			<div className="relative w-6 h-6">
				<span className={line1Classes}></span>
				<span className={line2Classes}></span>
				<span className={line3Classes}></span>
			</div>
		</button>
	);
}

export default HamburgerButton;
